import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '../../lib/react-router';
import HomePage from '@/features/home/HomePage';
import { rest } from '@/lib/hono-client';

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',

  beforeLoad: async () => {
    const whoami = await rest.api.auth.whoami.$get();
    console.debug('whoami', whoami);
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    if (!whoami.ok) throw redirect({ to: '/login' });
  },

  component: HomePage,
});

export const homeRoutes = [homeRoute];
